import { FIELD_BLANK_VALUES } from './constants';

import type { IntegrationVersionConfig } from './types';

export function formatIntegrationVersionConfig(
  integrationVersionConfig: any
): IntegrationVersionConfig {
  return {
    isStaticIPEnabled:
      integrationVersionConfig?.allow_static_ip ??
      FIELD_BLANK_VALUES.isStaticIPEnabled,
  };
}
